var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.c{fill:#fff;}.a{stroke:#fdb201;stroke-width:2px;}.b{fill:#fdb201;}.d{stroke:none;}.e{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-7142 -8477.901)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(7142 8477.901)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 28,
    cy: 28,
    r: 28
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 28,
    cy: 28,
    r: 27
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1934 -767.099)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M15.275,2.943a2,2,0,0,1,3.451,0L32.235,25.989A2,2,0,0,1,30.509,29H3.491a2,2,0,0,1-1.725-3.011Z",
    transform: "translate(5219 9255)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M-1.335-12.121,1.3-12.1.638-3.638H-.655ZM1.181-2.38V0H-1.2V-2.38Z",
    transform: "translate(5236 9280)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorSearch);
export default __webpack_public_path__ + "static/media/error-search.ab63aeafd363e8020ab74859b1bd8fb5.svg";
export { ForwardRef as ReactComponent };